import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const FrenchFlag = ({ width, height }) => (React__default.createElement(SvgImg, { viewbox: "0 0 15 9", title: "icons /french flag", width: width, height: height },
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 0H10V9H5V0Z", fill: "white" }),
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 0H15V9H10V0Z", fill: "#D80031" }),
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0H5V9H0V0Z", fill: "#323E95" })));

export { FrenchFlag };
